import { render, staticRenderFns } from "./Minicart.vue?vue&type=template&id=71f0362c&"
import script from "./Minicart.vue?vue&type=script&lang=js&"
export * from "./Minicart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports